// extracted by mini-css-extract-plugin
export const user__nav = "UserMenu-module--user__nav--vpR_p";
export const user__nav_option_disabled = "UserMenu-module--user__nav_option_disabled--1rsMg";
export const user__nav_option = "UserMenu-module--user__nav_option--2sOHR";
export const selected = "UserMenu-module--selected--2tNRq";